/**
 * Returns a number removed of commas with from a string
 * @param inputString
 * @returns {number}
 */

function removeCommasFromNumber(inputString = '') {
  if (isNaN(parseFloat(inputString))) return 'NaN';
  return parseInt(inputString.replace(/,/g, ''), 10);
}

export default removeCommasFromNumber;
